module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/desk-0854ad7856cca76d644d17cadbf8048e.svg";